export function commuteMonthRange(month: string) {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(month)) return null;
  const from = `${month}-01`;
  const last = new Date(`${from}T12:00:00.000Z`);
  if (!Number.isFinite(last.getTime())) return null;
  last.setUTCMonth(last.getUTCMonth() + 1, 0);
  return { from, to: last.toISOString().slice(0, 10) };
}

export const commuteClock = (value: string | null) => {
  if (!value) return "-";
  const match = /^(\d{1,2}):([0-5]\d)(?::([0-5]\d))?$/.exec(value.trim());
  if (!match || Number(match[1]) > 24 || Number(match[1]) === 24 && (match[2] !== "00" || Number(match[3] ?? 0) !== 0)) return "-";
  return `${match[1].padStart(2, "0")}:${match[2]}`;
};
